import { useQuery } from "@tanstack/react-query";
import { SessionFrame } from "@/components/session/SessionFrame";
import { RouteLoading, RouteError } from "@/components/layout/RouteStatus";
import { powtoonBE } from "@/lib/powtoon-be/client";

export function SessionPage({
  scenarioId, queryKey, publicLinkToken,
  notFoundTitle = "Session not found", notFoundMessage,
}: {
  scenarioId: string;
  queryKey: readonly unknown[];
  publicLinkToken?: string;
  notFoundTitle?: string;
  notFoundMessage?: React.ReactNode;
}) {
  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: () => powtoonBE.scenarios.get(scenarioId, { publicLinkToken }),
    retry: false,
  });
  if (isLoading) return <RouteLoading label="Loading session…" fullScreen />;
  if (error || !data) {
    return (
      <RouteError fullScreen
        message={(notFoundMessage as string) ?? `${notFoundTitle}: ${scenarioId} couldn't be loaded.`}
      />
    );
  }
  return <SessionFrame scenario={data} publicLinkToken={publicLinkToken} />;
}
